export default {
    confirmPasswordError: 'رمز عبور و تکرار آن باید یکسان باشند.',
    enterVerificationCode: 'کد ارسال شده به شماره همراه زیر را وارد کنید.',
    isIncorrect: '{0} وارد شده صحیح نیست.',
    isRequired: '{0} الزامی است.',
    loginError: 'نام کاربری و یا رمز عبور صحیح نیست.',
    noResult: 'موردی یافت نشد.',
    pageNotFound: 'صفحه مورد نظر یافت نشد.',
    passwordError: 'رمز عبور باید حداقل شامل 6 کاراکتر باشد.',
    rememberMe: 'مرا به خاطر بسپار',
    resetPasswordByEmailMessage: 'لینک بازیابی رمز عبور به ایمیل شما ارسال شده است، لطفا ایمیل خود را چک کنید.',
};
